import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { BarcodeEditorPreview, BarcodeEditorSideBar } from "../../containers";
import { getData_Object } from "../../containers/BarcodeEditorSideBar/helper";
import { getDataObjectKey } from "../../constants/barcodes";
import { getBarcodeLabels } from "../../containers/BarcodeEditorPreview/helper";

import BarcodeBuilderBar from "./BarcodeBuilderBar";
import { StyledEditorStack } from "./styles";
import { useSearchParams } from "react-router-dom";

const defaultGap = 5 / 32;
const defaultMargin = {
  top: 0.5,
  left: defaultGap,
  bottom: 0.5,
  right: defaultGap,
};

const BarcodeBuilderPageContent = ({ batch, disabled, serializationData }) => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const dataId = searchParams.get("id");

  const { watch, setValue, getValues } = useFormContext();
  const dataObject = type ?? watch("object");

  const data = serializationData ?? getData_Object(dataObject);

  const quantity = watch("quantity") ?? 1;
  const source = watch("source");

  const getNewQuantity = () => {
    const formSource = getValues("source");
    const key = getDataObjectKey(formSource)?.key;
    const qty = key ? data[key] : 1;

    setValue("quantity", qty);
  };

  useEffect(() => {
    getNewQuantity();
  }, [source, dataObject]);

  const size = watch("size");
  const format = watch("format");
  const fields = watch("barcode");
  const delimiter = watch("delimiter");
  const serialize = !!watch("serialize");
  const displayValue = !!watch("label");

  const topTemplates = watch("top") || [];
  const bottomTemplates = watch("bottom") || [];

  const pageType = !!watch("pageType");
  const margin = watch("margin") || defaultMargin;
  const columns = watch("columns") || 1;
  const rows = watch("rows") || 0;
  const columnGap = watch("columnGap") || defaultGap;
  const rowGap = watch("rowGap") || 0;

  const labels = getBarcodeLabels({
    data,
    fields,
    delimiter,
    serialize,
    topTemplates,
    bottomTemplates,
    useBmp: false,
    quantity,
  });

  const barcodeProps = {
    labels,
    size,
    pageType,
    serialize,
    format,
    displayValue,
    columns,
    columnGap,
    rows,
    rowGap,
    margin,
  };

  return (
    <>
      <BarcodeBuilderBar disabled={disabled} data={data} batch={batch} />
      <StyledEditorStack>
        <BarcodeEditorPreview {...barcodeProps} isPreview={!dataId} />
        <BarcodeEditorSideBar disabled={disabled} disableType={!!type} />
      </StyledEditorStack>
    </>
  );
};

export default BarcodeBuilderPageContent;
